import { IOperation, IPaginatedREST } from '../types'
import { BOWTIE_BASE_URL, BOWTIE_REST_ENDPOINTS } from '../utils/constants'

interface IQueryParams {
    perPage: number
    page: number
    keyword: string
    direction: string
    orderBy: string
}

export const getOperations = async (params?: IQueryParams): Promise<IPaginatedREST<IOperation>> => {
    const qs = new URLSearchParams({
        limit: params?.perPage?.toString() ?? '',
        offset: (Math.max(1, params?.page ?? 0) - 1)?.toString() ?? '0',
        keyword: params?.keyword?.toString() ?? '',
        orderBy: params?.orderBy?.toString() ?? 'id',
        direction: params?.direction?.toString() ?? 'ASC'
    }).toString()
    const data = await fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.operations}/?${qs}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })

    return data
}

export const createOperation = async (body: Omit<IOperation, 'id'>): Promise<IOperation> => {
    const data = await fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.operations}/`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })

    return data
}

export const updateOperation = async (body: IOperation): Promise<IOperation> => {
    const data = await fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.operations}/`, {
        method: 'PATCH',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })

    return data
}

export const deleteOperation = async (body: number): Promise<void> => {
    const data = await fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.operations}/${body}`, {
        method: 'DELETE',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}
